import { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { CandidatoService } from '../../candidato.service';

type ModalCorrigirDadosCandidatoProps = {
  show: boolean;
  candidatoId: number;
  emailAtual?: string | null;
  onHide: () => void;
  onSuccess: (novoEmail: string) => void;
};

const candidatoService = new CandidatoService();

export function ModalCorrigirDadosCandidato({
  show,
  candidatoId,
  emailAtual,
  onHide,
  onSuccess,
}: ModalCorrigirDadosCandidatoProps) {
  const [email, setEmail] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!show) return;
    setEmail((emailAtual ?? '').trim());
  }, [show, emailAtual]);

  const handleSubmit = async (ev: React.FormEvent) => {
    ev.preventDefault();
    const novoEmail = email.trim().toLowerCase();
    if (!novoEmail || !novoEmail.includes('@')) {
      toast.error('Informe um e-mail válido.');
      return;
    }
    if (novoEmail === (emailAtual ?? '').trim().toLowerCase()) {
      toast.info('O e-mail informado é igual ao atual.');
      return;
    }

    setSaving(true);
    try {
      await candidatoService.corrigirEmail(candidatoId, novoEmail);
      toast.success('E-mail do candidato atualizado.');
      onSuccess(novoEmail);
      onHide();
    } catch (error) {
      toast.error(error instanceof Error ? error.message : String(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={saving ? undefined : onHide} centered>
      <Form onSubmit={(ev) => void handleSubmit(ev)}>
        <Modal.Header closeButton={!saving}>
          <Modal.Title>Correção de dados do candidato</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted small mb-3">
            Altere o e-mail cadastrado na inscrição do candidato.
          </p>
          <Form.Group controlId="corrigir-email-candidato">
            <Form.Label>E-mail</Form.Label>
            <Form.Control
              type="email"
              value={email}
              disabled={saving}
              autoFocus
              required
              onChange={(ev) => setEmail(ev.target.value)}
              placeholder="novo@email.com"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide} disabled={saving}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {saving ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                Salvando…
              </>
            ) : (
              'Salvar e-mail'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
